export default __webpack_public_path__ + "static/media/photo4.8110ab6f.jpg";